<template>
  <div class="sc-comparison-table">
    <div class="row-header">
      <vnodes :vnodes="this.$slots.rowHeader"/>
    </div>
    <vnodes :vnodes="this.$slots.column"/>
  </div>
</template>
<script>
export default {
  name: 'ScComparisonTableComponent',
  components: {
    Vnodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes
    }
  }
}

</script>
<style scoped lang="scss">
.sc-comparison-table {
  display: flex;
  flex-direction: row;

  .row-header {
    display: flex;
    flex-direction: column;
    margin-top: auto;
  }
}
</style>
